import {
    ExclamationTriangleIcon,
    InformationCircleIcon,
    NoSymbolIcon
} from '@heroicons/react/24/outline';
import type { ComponentType } from 'react';

// Keep in sync with backend Zod schema in
// backend/src/routes/api/v2/patients/notes/notes.validator.ts
export const MAX_NOTE_TITLE_LENGTH = 120;
export const MAX_NOTE_BODY_LENGTH = 20000;

export type SeverityKey = 'info' | 'warning' | 'critical';

export interface SeverityConfig {
    label: string;
    icon: ComponentType<{ className?: string }>;
    dot: string;
    border: string;
    bg: string;
    iconColor: string;
    pillBg: string;
    ring: string;
    badgeBg: string;
}

export const SEVERITY: Record<SeverityKey, SeverityConfig> = {
    info: {
        label: 'Info',
        icon: InformationCircleIcon,
        dot: 'bg-blue-400',
        border: 'border-blue-200',
        bg: 'bg-blue-50',
        iconColor: 'text-blue-500',
        pillBg: 'bg-blue-50 text-blue-700',
        ring: 'ring-blue-200',
        badgeBg: 'bg-blue-100 text-blue-700'
    },
    warning: {
        label: 'Warning',
        icon: ExclamationTriangleIcon,
        dot: 'bg-amber-400',
        border: 'border-amber-200',
        bg: 'bg-amber-50',
        iconColor: 'text-amber-500',
        pillBg: 'bg-amber-50 text-amber-700',
        ring: 'ring-amber-200',
        badgeBg: 'bg-amber-100 text-amber-700'
    },
    critical: {
        label: 'Critical',
        icon: NoSymbolIcon,
        dot: 'bg-red-500',
        border: 'border-red-200',
        bg: 'bg-red-50',
        iconColor: 'text-red-500',
        pillBg: 'bg-red-50 text-red-700',
        ring: 'ring-red-200',
        badgeBg: 'bg-red-100 text-red-700'
    }
};
